import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'
import Login from '@/views/Login.vue'
import Team from '@/views/Team.vue'
import Flow from '@/views/Flow.vue'
import Manage from '@/views/Manage.vue'
import Establishment from '@/views/Establishment.vue'
import EstablishmentHome from '@/views/EstablishmentHome.vue'
import GatheringHome from '@/views/GatheringHome.vue'
import ConsultantLinks from '@/views/ConsultantLinks.vue'
import Profile from '@/views/Profile.vue'
import Laboratory from '@/views/Laboratory.vue'
import Link from './views/Link.vue'

import store from '@/store.coffee'
import utils from '@/utils.coffee'
import CanNotAccess from './views/CanNotAccess.vue'

Vue.use(Router)

function intersect(a, b) {
    // var setB = new Set(b);
    // return [...new Set(a)].filter(x => setB.has(x));
    if (b == null) {
        return []
    }
    return a.filter(value => -1 !== b.indexOf(value));
}

var router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
            redirect: function () {
                var ret = '/login/';
                if (store.state.profile == null) {
                    ret = '/login/';
                } else if (intersect(['establishment_staff'], store.state.profile.groups).length > 0) {
                    ret = '/g/';
                } else if (intersect(['gathering_staff'], store.state.profile.groups).length > 0) {
                    ret = '/g/';
                } else if (intersect(['consultants'], store.state.profile.groups).length > 0) {
                    ret = '/team'
                } else {
                    ret = '/login/';
                }
                return ret
            },
            meta: {
                authRequired: true,
                allowed_groups: null,
                needed_permissions: null,
            },
            children: [{
                path: '/team',
                name: 'team',
                component: Team,
                meta: {
                    authRequired: true,
                    allowed_groups: null,
                    needed_permissions: ["game.can_access_team"],
                }
            }, {
                path: '/team/:uid',
                name: 'team_detail',
                component: Team,
                meta: {
                    authRequired: true,
                    allowed_groups: null,
                    needed_permissions: ["game.can_access_team"],
                }
            }, {
                path: '/flow',
                name: 'flow',
                component: Flow,
                meta: {
                    authRequired: true,
                    allowed_groups: null,
                    needed_permissions: ["game.can_access_flow"],
                }
            }, {
                path: '/flow/:uid',
                name: 'flow_detail',
                component: Flow,
                meta: {
                    authRequired: true,
                    allowed_groups: null,
                    needed_permissions: ["game.can_access_flow"],
                }
            }, {
                path: '/manage/:uid?',
                name: 'manage',
                component: Manage,
                meta: {
                    authRequired: true,
                    allowed_groups: null,
                    needed_permissions: ["game.can_access_manage"],
                }
            }, {
                path: '/establishment/:uid?',
                name: 'establishment',
                component: Establishment,
                meta: {
                    authRequired: true,
                    allowed_groups: null,
                    needed_permissions: ["game.can_access_establishment"],
                }
            }, {
                path: '/profile',
                name: 'profile',
                component: Profile,
                meta: {
                    authRequired: true,
                    allowed_groups: null,
                    needed_permissions: ["game.can_access_import_review"],
                }
            }, {
                path: '/laboratory',
                name: 'laboratory',
                component: Laboratory,
                meta: {
                    authRequired: true,
                    // TODO : Only allowed users can access the laboratory
                    allowed_groups: null,
                    needed_permissions: ["game.can_access_lab"],
                }
            }, {
                path: '/links',
                name: 'link',
                component: Link,
                meta: {
                    authRequired: true,
                    allowed_groups: null,
                    needed_permissions: ["game.can_access_links"],
                }
            },
            {
                path: '/external-links/:uid?',
                name: 'consultantLinks',
                component: ConsultantLinks,
                meta: {
                    authRequired: true,
                    allowed_groups: ['consultants'],
                    needed_permissions: null,
                }
            },
            {
                path: '/manage',
            }
            ]
        }, {
            path: '/g/:establishment_uid?',
            name: 'gathering_home',
            component: GatheringHome,
            meta: {
                authRequired: true,
                allowed_groups: ['gathering_staff', 'establishment_staff'],
                needed_permissions: null,
            },
        }, {
            path: '/g/:establishment_uid/:review_uid?',
            name: 'gathering_review',
            component: GatheringHome,
            meta: {
                authRequired: true,
                allowed_groups: ['gathering_staff', 'establishment_staff'],
                needed_permissions: null,
            },
        }, {
            path: '*',
            redirect: function () {
                var ret = '/';
                if (store.state.profile == null) {
                    ret = '/';
                } else if (intersect(['gathering_staff', 'establishment_staff'],
                                     store.state.profile.groups).length > 0) {
                    ret = '/g/';
                } else if (intersect(['consultants'],
                                     store.state.profile.groups).length > 0) {
                    ret = '/team';
                } else {
                    ret = '/login';
                }
                return ret;
            }
        }, {
            path: '/can-not-access',
            name: 'Can_not_access',
            component: CanNotAccess,
            meta: {
                authRequired: true,
                allowed_groups: null,
                needed_permissions: null,
            }        
        }, {
            path: '/login:next',
            name: 'login',
            component: Login,
            meta: {
                authRequired: false,
                allowed_groups: null,
                needed_permissions: null,
            }
        }, {
            path: '/login',
            name: 'login',
            component: Login,
            meta: {
                authRequired: false,
                allowed_groups: null,
                needed_permissions: null,
            }
        }
    ]
})


function check_modified_fields(){
    var allow = true
    var notify_text = "Les champs suivants ne seront pas enregistrés si vous continuez" +
        "<ul style='list-style:disc;margin-left:10px;'>";
    for (var key in store.state.edited_fields) {
        var f = store.state.edited_fields[key]
        if ([null, ""].indexOf(f.value) < 0) {
            allow = false;
            notify_text += "<li>" + f.verbose_name + "</li>";
            utils.highlight_element(f.el, 2)
            f.el.focus()
        }
    }
    notify_text += "</ul>";
    return {allow, notify_text}
}


function check_user_permissions(user_perms, route_perms){
    let ret = false
    if(route_perms){
        ret = intersect(
            user_perms,
            route_perms
        ).length > 0
    }else{
        // -- if route_perms is null, it means no permissions needed
        ret = true
    }
    return ret
}

function check_user_group_for_route(user_groups, route_groups){
    let ret = false
    // console.log("check_user_group_for_route", user_groups, route_groups)
    if(route_groups){
        ret = intersect(
            user_groups,
            route_groups
        ).length > 0
    }else{
        // -- if route_groups is null, it means no group needed
        ret = true        
    }
    return ret
}


function find_available_route_for_user(user_groups, user_permissions){
    let firstAvailableRoute = '/can-not-access'
    let accessibleRoutes = []
    for(let route of router.options.routes){
        if(route.children){
            for(let subRoute of route.children){
                // console.log(subRoute.path)
                if(subRoute.meta){
                    // console.log("    #perms", subRoute.meta.needed_permissions)
                    // console.log("    #group", subRoute.meta.allowed_groups)
                    // -- check permissions 
                    let perm_condition = check_user_permissions(
                        user_permissions,
                        subRoute.meta.needed_permissions
                    )
                    // -- check groups
                    let group_condition = check_user_group_for_route(
                        user_groups,
                        subRoute.meta.allowed_groups
                    )
                    if (
                        group_condition && 
                        perm_condition && 
                        subRoute.name != "login" && 
                        subRoute.name != "home"
                    ){
                        accessibleRoutes.push(subRoute)
                    }
                }
            }
        }else{
            if(route.meta){
                // console.log("    #perms", route.meta.needed_permissions)
                // console.log("    #group", route.meta.allowed_groups)
                // -- check permissions 
                let perm_condition = check_user_permissions(
                    user_permissions,
                    route.meta.needed_permissions
                )
                // -- check groups
                let group_condition = check_user_group_for_route(
                    user_groups,
                    route.meta.allowed_groups
                )
                if (
                    group_condition && 
                    perm_condition && 
                    route.name != "login" && 
                    route.name != "home"
                ){
                    accessibleRoutes.push(route)
                }                
            }
        }
    }
    // console.log('accessibleRoutes', accessibleRoutes)
    if(accessibleRoutes.length > 0){
        firstAvailableRoute = accessibleRoutes[0].path
    }
    return firstAvailableRoute
}


router.beforeEach(function (to, from, next) {
    // console.log("beforeEach", from.path, to.path)
    if (!store.state.authenticated && to.meta.authRequired) {
        // -- target path may need authentication
        router.push({ name: "login", params: { "next": to.path } })
    } else {
        if (!store.state.authenticated || store.state.profile == null) {
            // -- force store initialiszation with profile
            next()
        } else {
            // -- check permissions 
            let perm_condition = check_user_permissions(
                store.state.profile.permissions,
                to.meta.needed_permissions
            )
            // -- check groups
            let group_condition = check_user_group_for_route(
                store.state.profile.groups,
                to.meta.allowed_groups
            )

            // console.log(`path:${to.path}\n`+
            //             `perm_condition: ${perm_condition}\n`+
            //             `group_condition: ${group_condition}`)
                        
            // -- if condition are not satisfied, find an ok route
            if (!(perm_condition && group_condition)) {
                let firstAccessibleRoute = find_available_route_for_user(
                    store.state.profile.groups,
                    store.state.profile.permissions
                )
                router.push(firstAccessibleRoute)
            }

            // -- edge case on '/can-not-access', with a refresh we want our new access
            if (to.path == '/can-not-access'){
                let firstAccessibleRoute = find_available_route_for_user(
                    store.state.profile.groups,
                    store.state.profile.permissions
                )
                if (firstAccessibleRoute && firstAccessibleRoute != '/can-not-access'){
                    router.push(firstAccessibleRoute)
                }
            }           
            
            // -- if route is ok, check modified fields
            var field_check = check_modified_fields()
            if (field_check.allow == true) {
                next()
            } else {
                store.dispatch("notify", {
                    text: field_check.notify_text,
                    seconds: 5,
                    level: "danger"
                })
            }
        }
    }
})

export default router
